import { useCallback, useState } from "react";

export default function useForceUpdate(): VoidFunction {
    const [, setValue] = useState({});

    return useCallback((): void => {
        setValue(new Object(null));
    }, []);
}
